import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Browse from "./pages/Browse";
import EmployeeProfile from "./pages/EmployeeProfile";
import CustomerDashboard from "./pages/CustomerDashboard";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import Messages from "./pages/Messages";
import Pricing from "./pages/Pricing";
import Reports from "./pages/Reports";
import ContractsList from "./pages/ContractsList";
import ContractDetail from "./pages/ContractDetail";
import InstallNudge from "./components/InstallNudge";
import "@/App.css";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/employees/:id" element={<EmployeeProfile />} />
            <Route path="/customer" element={<Protected roles={["customer"]}><CustomerDashboard /></Protected>} />
            <Route path="/employee" element={<Protected roles={["employee"]}><EmployeeDashboard /></Protected>} />
            <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
            <Route path="/messages" element={<Protected><Messages /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/contracts" element={<Protected><ContractsList /></Protected>} />
            <Route path="/contracts/:id" element={<Protected><ContractDetail /></Protected>} />
          </Routes>
        </BrowserRouter>
        <InstallNudge />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
